export default "__VITE_ASSET__BD1sFgyH__"